
import {joinGetParams} from './tools'
export class Request{
    /** get请求 */
    private static requestGet(params: requestParams) {
        const {url,data = {},success=null,fail=null,header={},timeout} = params;
        let _data = joinGetParams(data);
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url + "?" + decodeURIComponent(_data), true);
        timeout&&(xhr.timeout = timeout)
        xhr.onreadystatechange = function() {
            let _datas:any  = null;
            if (xhr.readyState == 4 && xhr.status == 200 || xhr.status == 304) {
                try{
                    _datas = typeof xhr.responseText == "string" ? JSON.parse(xhr.responseText) : xhr.responseText
                }catch(e){
                    _datas = xhr.responseText
                }
                success&&success.call(this, _datas);
            } else if (xhr.status && xhr.status != 200) {
                //TODO 统一错误处理
                fail&&fail.call(this, _datas);
            }
        };
        xhr.send();
    }
    /** post请求 */
    private static requestPost(params:requestParams) {
        const {url,data = {},success=null,fail=null,header={},ext={},timeout} = params;
        var xhr = new XMLHttpRequest();
        xhr.open("POST", url, true);
        timeout&&(xhr.timeout = timeout)
        if(!ext.notX8){
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        }
        for(const i in header){
            xhr.setRequestHeader(i, header[i]);
        }
        xhr.onreadystatechange = function() {
            let _datas:any = null;
            if (xhr.readyState == 4 && xhr.status == 200 || xhr.status == 304) {
                try{
                    _datas = typeof xhr.responseText == "string" ? JSON.parse(xhr.responseText) : xhr.responseText
                }catch(e){
                    _datas = xhr.responseText;
                }
                success&&success.call(this, _datas);
            } else if (xhr.status && xhr.status != 200) {
                //TODO 统一错误处理
                fail&&fail.call(this, _datas);
            }
        };
        xhr.send(JSON.stringify(data));
    }
    /** 请求 */
    public static create(params:requestParams):Promise<any>{
        const {url,type='get',data={},header={},ext={},timeout} = params;
        // let x8Config = DataManage.getInstance().getSpaceData({
        //     spaceName:'sdk',
        // });
        // let x8RequestUrl = x8Config.x8_request_url;
        // let x8ReportUrl = x8Config.x8_request_url;
        // let postUrl = '';
        // if(url.indexOf('/x8request')!=-1){
        //     postUrl = url.replace('/x8request',x8RequestUrl)
        // }else if(url.indexOf('/x8rpt')!=-1){
        //     postUrl = url.replace('/x8report',x8ReportUrl)
        // }
        return new Promise((resolve,reject)=>{
            switch(type?.toLowerCase()){
                case 'get':
                    this.requestGet({
                        url,
                        data,
                        header,
                        ext,
                        timeout,
                        success:(res: any)=>{
                            resolve(res);
                        },
                        fail:(res: any)=>{
                            reject(res);
                        }
                    });
                    break;
                case 'post':
                    this.requestPost({
                        url,
                        data,
                        header,
                        ext,
                        timeout,
                        success:(res: any)=>{
                            resolve(res);
                        },
                        fail:(res: any)=>{
                            reject(res);
                        }
                    });
                    break;
            }
        });
    }
}